import { cn } from "@tellescope/design-system";
import { type ComboboxOption } from "@tellescope/ui";
import { Check } from "lucide-react";

export interface ContentComboboxOptionProps {
  option: ComboboxOption;
  isSelected: boolean;
}

export const ContentComboboxOption = ({ option, isSelected }: ContentComboboxOptionProps) => (
  <>
    <div className="flex w-full min-w-0 flex-col gap-1">
      <div className="text-sm font-medium break-words">{option.label}</div>
      {option.description && <div className="text-xs text-muted-foreground break-words">{option.description}</div>}
    </div>
    <Check className={cn("ml-auto h-4 w-4 shrink-0", isSelected ? "opacity-100" : "opacity-0")} />
  </>
);
